<template>
  <div :class="$style.base">
    <Mock v-if="widgetSettings.mock" />
    <WaitingList v-else-if="waitingList" />
    <DefaultPage v-else />
  </div>
</template>

<script setup lang="ts">
import { useBookingStore } from '@/stores/booking';
import widgetSettings from '@/widget-settings';
import { inject } from 'vue';
import Mock from './Mock.vue';
import WaitingList from './WaitingList.vue';
import DefaultPage from './default/index.vue';

const { waitingList } = useBookingStore();

const gtag = inject<any>('gtag');
gtag.trackEvent('booking_completed');
</script>

<style lang="scss" module>
.base {
  padding: $spacing;
}
</style>
